import React from "react";
import Header from "../../components/Header"; 
import Footer from "../../components/Footer";
import UserLeftSidebar from "../Components/UserLeftSidebar";
import SupportRight from "../Layouts/SupportRight";

export default function Support() {
  return (
    <div>
      <Header mode="dark" />

      <div className="container-fluid">
        <div className="dashboard-full-page">
          <UserLeftSidebar />
          <SupportRight />
        </div>
      </div>
 
      <Footer />
    </div>
  );
}
